import moment from "moment";
import { Link } from "react-router-dom";

import DocumentNameView from "@/Components/compliance/DocumentNameView";
import { DownArrowIcon } from "@/Components/Icons/DownArrowIcon";

import { sortByText } from "../DataTableSorting";
import { getComplianceStatusClass } from "../utils";

const commonClasses = {
  base: "text-[14px] font-medium leading-[normal] text-black",
  truncate: "truncate",
  capitalize: "capitalize",
  smallText: "text-[12px] font-semibold leading-[normal] text-txtColor ",
  flexCol: "flex flex-col gap-1",
  flexRow: "flex gap-1",
  link: "text-[14px] font-semibold leading-[normal] !text-black",
  expandButton:
    "transition-linear pointer-events-none grid h-[24px] w-[24px] place-items-center bg-none text-txtColor",
};

export const getColumnNormalHtml = (value, cls = "") => {
  return <span className={`${commonClasses.base} ${cls}`}>{value}</span>;
};

export const getActionByHtml = (
  ActionName,
  ActionDate,
  ActionedFrom = 0,
  cls = "",
) => {
  let date = moment(ActionDate, "DD/MM/YYYY HH:mm", true).isValid()
    ? moment(ActionDate, "DD/MM/YYYY HH:mm").format("DD/MM/YYYY")
    : "-";

  let time = moment(ActionDate, "DD/MM/YYYY HH:mm", true).isValid()
    ? moment(ActionDate, "DD/MM/YYYY HH:mm").format("hh:mm A")
    : "-";

  let formattedActionName = ActionName;
  // if (ActionedFrom == 1) {
  //   const words = ActionName.split(" ");
  //   if (words.length > 1) {
  //     const firstChar = `${words[0]} ${words[1].charAt(0)}`;
  //     formattedActionName = (
  //       <>
  //         <span className="!mr-2">{firstChar}</span>
  //         {/* <span className="inline-block !rounded-[4px] bg-lightblue px-2 py-[5px] text-[12px] leading-4 text-primary">
  //           AppLocum
  //         </span> */}
  //       </>
  //     );
  //   }
  // }

  return (
    <>
      <div className="flex flex-col gap-1">
        <span
          className={`${commonClasses.base} ${commonClasses.capitalize} ${commonClasses.trunate} ${cls} line-clamp-2 whitespace-normal break-words`}
        >
          {formattedActionName || "-"}
        </span>
        {date !== "-" || time !== "-" ? (
          <div className={commonClasses.flexRow}>
            <span className={commonClasses.smallText}>{date}</span>
            <span className={commonClasses.smallText}>{time}</span>
          </div>
        ) : (
          "-"
        )}
      </div>
    </>
  );
};

export const totalDaysColumn = (
  name,
  key,
  width = "120px",
  isSortable = false,
  redirectLink = "",
) => {
  return {
    name: name,
    sortable: isSortable,
    // sortFunction: (rowA, rowB) => sortByNumber(rowA, rowB, key),
    selector: (row) => {
      return (
        <div className={commonClasses.flexCol} data-tag="allowRowEvents">
          {redirectLink ? (
            <Link
              to={redirectLink}
              className={commonClasses.link}
              state={{
                contractReferenceNo: row.contract_ref_no,
                listView: "shifts",
              }}
            >
              {row[key] ? row[key] : 0}
            </Link>
          ) : (
            <span className={commonClasses.link}>
              {row[key] ? row[key] : 0}
            </span>
          )}
        </div>
      );
    },
    width,
  };
};

export const expandButtonColumn = () => {
  return {
    id: "expand-btn",
    name: " ",
    sortable: false,
    selector: (row) => (
      <div data-tag="allowRowEvents">
        <div className={commonClasses.expandButton}>
          <DownArrowIcon />
        </div>
      </div>
    ),
    width: "auto",
  };
};

export const complianceListColumn = {
  title: (
    canViewCompliance = false,
    setOpenedPopoverRow,
    openedPopoverRow,
    candidate_id,
  ) => {
    return {
      name: "Title",
      sortable: true,
      sortFunction: (rowA, rowB) => sortByText(rowA, rowB, "name"),
      selector: (row) => {
        // const canViewCompliance = !clientUserAllPermissions || clientUserAllPermissions?.is_allow_to_view_download_compliance;
        const hasDocuments =
          Array.isArray(row.document_url) && row.document_url?.length > 0;

        return (
          <DocumentNameView
            hasDocuments={hasDocuments}
            document_url={row.document_url}
            name={row.name}
            candidate_id={candidate_id}
            setOpenedPopoverRow={setOpenedPopoverRow}
            openedPopoverRow={openedPopoverRow}
            document_id={row?.document_id}
            canViewCompliance={canViewCompliance}
          />
        );
      },
      width: "32%",
    };
  },
  uploaded: (showStatus) => {
    return {
      name: "Uploaded",
      sortable: true,
      sortFunction: (rowA, rowB) =>
        sortByDateTime(rowA.uploaded_date, rowB.uploaded_date),
      selector: (row) => (
        <div className="grid gap-2">
          {getColumnNormalHtml(row.uploaded_date)}
          {showStatus &&
            (row.status_title ? (
              <span
                className={`h-[24px] rounded-[5px] border px-2 text-center text-[12px] leading-[22px] ${getComplianceStatusClass(
                  row.status_title,
                )}`}
              >
                {row.status_title}
              </span>
            ) : null)}
        </div>
      ),
    };
  },
  approvedBy: {
    name: "Approved By",
    sortable: false,
    selector: (row) => (
      <div className="flex flex-col items-start gap-1">
        {row.approved_by && row.approved_by !== "-"
          ? getColumnNormalHtml(row.approved_by)
          : null}
      </div>
    ),
  },
  dateOfUpdate: {
    name: "Date Of Update",
    sortable: true,
    sortFunction: (rowA, rowB) =>
      sortByDateTime(rowA.updated_date, rowB.updated_date),
    selector: (row) =>
      getColumnNormalHtml(row.updated_date ? row.updated_date : "-"),
  },
  expiryDate: {
    name: "Expiry Date",
    sortable: true,
    sortFunction: (rowA, rowB) =>
      sortByDateTime(rowA.expiry_date, rowB.expiry_date),
    selector: (row) => getColumnNormalHtml(row.expiry_date),
  },
};
